import $api from "@/assets/js/api.js";
import $router from "@/router";
import $errors from "@/assets/js/errors.js";
import $moment from "moment";

const FileSaver = require("file-saver");

const state = {
  projects: null,
  projectsStats: null,
  projectsStati: null,
  currentProject: null,
  currentProjectCustomFields: null,
  currentProjectCrmFields: null,
  currentProjectMessages: null,
  currentProjectsMessages: null,
  currentProjectsMessagesPagination: null,
  currentProjectsMessagesWhatsappMeta: null,
  currentProjectFiles: null,
  currentProjectStats: null,
  currentProjectStati: null,
  currentProjectTags: null,
  currentProjectTagsPagination: null,
  newProjectClient: null,
  messagesPagination: null,
  builderSession: null,
  currentProjectGuests: null,
  previousCurrentProject: null,
};

const getters = {
  projects_get_project_list: (state) => {
    return state.projects;
  },
  projects_get_projects_stats: (state) => {
    return state.projectsStats;
  },
  projects_get_projects_stati: (state) => {
    return state.projectsStati;
  },
  projects_get_current_project: (state) => {
    return state.currentProject;
  },
  projects_get_current_project_custom_fields: (state) => {
    return state.currentProjectCustomFields;
  },
  projects_get_current_project_crm_fields: (state) => {
    return state.currentProjectCrmFields;
  },
  projects_get_builder_session: (state) => {
    return state.builderSession;
  },
  projects_get_new_project_client: (state) => {
    return state.newProjectClient;
  },
  projects_get_current_project_messages: (state) => {
    return state.currentProjectMessages;
  },
  projects_get_current_projects_messages: (state) => {
    return state.currentProjectsMessages;
  },
  projects_get_current_projects_messages_pagination: (state) => {
    return state.currentProjectsMessagesPagination;
  },
  projects_get_current_projects_messages_whatsapp_meta: (state) => {
    return state.currentProjectsMessagesWhatsappMeta;
  },
  projects_get_messages_pagination: (state) => {
    return state.messagesPagination;
  },
  projects_get_current_project_files: (state) => {
    return state.currentProjectFiles;
  },
  projects_get_current_project_stats: (state) => {
    return state.currentProjectStats;
  },
  projects_get_current_project_stati: (state) => {
    return state.currentProjectStati;
  },
  projects_get_current_project_tags: (state) => {
    return state.currentProjectTags;
  },
  projects_get_current_project_tags_pagination: (state) => {
    return state.currentProjectTagsPagination;
  },
  projects_get_current_project_guests: (state) => {
    return state.currentProjectGuests;
  },
  projects_get_previous_current_project: (state) => {
    return state.previousCurrentProject;
  },
};

const mutations = {
  PROJECTS_SET_PROJECT_LIST(state, projects) {
    state.projects = projects;
  },
  PROJECTS_SET_PROJECTS_STATS(state, stats) {
    state.projectsStats = stats;
  },
  PROJECTS_SET_PROJECTS_STATI(state, stati) {
    state.projectsStati = stati;
  },
  PROJECTS_SET_CURRENT_PROJECT(state, project) {
    state.currentProject = project;
  },
  PROJECTS_SET_CURRENT_PROJECT_CUSTOM_FIELDS(state, customFields) {
    state.currentProjectCustomFields = customFields;
  },
  PROJECTS_SET_CURRENT_PROJECT_CRM_FIELDS(state, crmFields) {
    state.currentProjectCrmFields = crmFields;
  },
  PROJECTS_SET_BUILDER_SESSION(state, builderSession) {
    state.builderSession = builderSession;
  },
  PROJECTS_SET_NEW_PROJECT_CLIENT(state, client) {
    state.newProjectClient = client;
  },
  PROJECTS_SET_PROJECT_MESSAGES(state, data) {
    data.messages = Array.isArray(data.messages) ? data.messages : [];
    const currentMessages = Array.isArray(state.currentProjectMessages) ? state.currentProjectMessages : [];
    data.messages.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    if (data.reset) {
      state.currentProjectMessages = Array.isArray(data.messages) ? data.messages : [];
    } else {
      state.currentProjectMessages = [...data.messages, ...currentMessages];
    }
  },
  PROJECTS_SET_PROJECTS_MESSAGES(state, messages) {
    state.currentProjectsMessages = messages;
  },
  PROJECTS_SET_PROJECTS_MESSAGES_PAGINATION(state, pagination) {
    state.currentProjectsMessagesPagination = pagination;
  },
  PROJECTS_SET_MESSAGES_PAGINATION(state, pagination) {
    state.messagesPagination = pagination;
  },
  PROJECTS_SET_PROJECTS_MESSAGES_WHATSAPP_META(state, meta) {
    state.currentProjectsMessagesWhatsappMeta = meta;
  },
  PROJECTS_SET_PROJECT_FILES(state, files) {
    state.currentProjectFiles = files;
  },
  PROJECTS_RESET_CURRENT_PROJECT_FILES(state) {
    state.currentProjectFiles = null;
  },
  PROJECTS_SET_PROJECT_STATS(state, stats) {
    state.currentProjectStats = stats;
  },
  PROJECTS_SET_PROJECT_STATI(state, stati) {
    state.currentProjectStati = stati;
  },
  PROJECTS_SET_CURRENT_PROJECT_TAGS(state, tags) {
    state.currentProjectTags = tags;
  },
  PROJECTS_SET_CURRENT_PROJECT_TAGS_PAGINATION(state, pagination) {
    state.currentProjectTagsPagination = pagination;
  },
  PROJECTS_SET_CURRENT_PROJECT_GUESTS(state, guests) {
    state.currentProjectGuests = guests;
  },
  PROJECTS_SET_PREVIOUS_CURRENT_PROJECT(state, project) {
    state.previousCurrentProject = project;
  },
};

const actions = {
  getProjectList({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");

      const urlParams = new URLSearchParams(window.location.search);
      const queryParamFrom = urlParams.get("from");
      if (queryParamFrom) {
        dispatch("resetProjectFilterValues", payload);
      }
      if (queryParamFrom === "hot-projects") {
        payload.params.order_col = "ces_daily";
        payload.params.order_dir = "DESC";
        payload.params.has_ces_daily_above = 25;
      } else if (queryParamFrom === "action-required-projects") {
        payload.params.order_col = "ces_daily";
        payload.params.order_dir = "ASC";
        payload.params.action_required = true;
      } else if (queryParamFrom === "dead-projects") {
        payload.params.order_col = "created_at";
        payload.params.order_dir = "DESC";
        payload.params.is_posted = true;
        payload.params.time_col = "last_active_at";
        payload.params.time_relative = "custom";
        payload.params.time_from = $moment.tz($moment().subtract(50, "y"), payload.timezone).format();
        payload.params.time_to = $moment.tz($moment().subtract(7, "d"), payload.timezone).format();
      } else if (queryParamFrom === "live-visitors") {
        payload.params.order_col = "last_active_at";
        payload.params.order_dir = "DESC";
      }

      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "last_active_at",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "DESC",
        search: payload.params.search ? payload.params.search : "",
        external_id: payload.params.external_id ? payload.params.external_id : "",
        custom: payload.params.custom ? payload.params.custom : "",
        include_stats:
          typeof payload.params.include_stats !== "undefined" && payload.params.include_stats !== null
            ? payload.params.include_stats
            : "",
        include_message_count:
          typeof payload.params.include_message_count !== "undefined" && payload.params.include_message_count !== null
            ? payload.params.include_message_count
            : "",
        include_unread_message_count:
          typeof payload.params.include_unread_message_count !== "undefined" &&
          payload.params.include_unread_message_count !== null
            ? payload.params.include_unread_message_count
            : "",
        include_latest_message_date:
          typeof payload.params.include_latest_message_date !== "undefined" &&
          payload.params.include_latest_message_date !== null
            ? payload.params.include_latest_message_date
            : "",
        include_subscribed:
          typeof payload.params.include_subscribed !== "undefined" && payload.params.include_subscribed !== null
            ? payload.params.include_subscribed
            : "",
        is_posted:
          typeof payload.params.is_posted !== "undefined" && payload.params.is_posted !== null
            ? payload.params.is_posted
            : "",
        is_visited:
          typeof payload.params.is_visited !== "undefined" && payload.params.is_visited !== null
            ? payload.params.is_visited
            : "",
        is_mine:
          typeof payload.params.is_mine !== "undefined" && payload.params.is_mine !== null
            ? payload.params.is_mine
            : "",
        is_private:
          typeof payload.params.is_private !== "undefined" && payload.params.is_private !== null
            ? payload.params.is_private
            : "",
        is_archived:
          typeof payload.params.is_archived !== "undefined" && payload.params.is_archived !== null
            ? payload.params.is_archived
            : "",
        is_subscribed:
          typeof payload.params.is_subscribed !== "undefined" && payload.params.is_subscribed !== null
            ? payload.params.is_subscribed
            : "",
        has_uploads:
          typeof payload.params.has_uploads !== "undefined" && payload.params.has_uploads !== null
            ? payload.params.has_uploads
            : "",
        has_downloads:
          typeof payload.params.has_downloads !== "undefined" && payload.params.has_downloads !== null
            ? payload.params.has_downloads
            : "",
        has_file_signings:
          typeof payload.params.has_file_signings !== "undefined" && payload.params.has_file_signings !== null
            ? payload.params.has_file_signings
            : "",
        has_messages:
          typeof payload.params.has_messages !== "undefined" && payload.params.has_messages !== null
            ? payload.params.has_messages
            : "",
        has_any_messages:
          typeof payload.params.has_any_messages !== "undefined" && payload.params.has_any_messages !== null
            ? payload.params.has_any_messages
            : "",
        has_unread_messages:
          typeof payload.params.has_unread_messages !== "undefined" && payload.params.has_unread_messages !== null
            ? payload.params.has_unread_messages
            : "",
        action_required:
          typeof payload.params.action_required !== "undefined" && payload.params.action_required !== null
            ? payload.params.action_required
            : "",
        has_ces_daily_above:
          typeof payload.params.has_ces_daily_above !== "undefined" && payload.params.has_ces_daily_above !== null
            ? payload.params.has_ces_daily_above
            : "",
        has_ces_total_above:
          typeof payload.params.has_ces_total_above !== "undefined" && payload.params.has_ces_total_above !== null
            ? payload.params.has_ces_total_above
            : "",
        has_file_previews:
          typeof payload.params.has_file_previews !== "undefined" && payload.params.has_file_previews !== null
            ? payload.params.has_file_previews
            : "",
        with_status:
          typeof payload.params.with_status !== "undefined" && payload.params.with_status !== null
            ? payload.params.with_status
            : "",
        without_status:
          typeof payload.params.without_status !== "undefined" && payload.params.without_status !== null
            ? payload.params.without_status
            : "",
        with_tag:
          typeof payload.params.with_tag !== "undefined" && payload.params.with_tag !== null
            ? payload.params.with_tag
            : "",
        without_tag:
          typeof payload.params.without_tag !== "undefined" && payload.params.without_tag !== null
            ? payload.params.without_tag
            : "",
        with_template:
          typeof payload.params.with_template !== "undefined" && payload.params.with_template !== null
            ? payload.params.with_template
            : "",
        without_template:
          typeof payload.params.without_template !== "undefined" && payload.params.without_template !== null
            ? payload.params.without_template
            : "",
        with_user:
          typeof payload.params.with_user !== "undefined" && payload.params.with_user !== null
            ? payload.params.with_user
            : "",
        without_user:
          typeof payload.params.without_user !== "undefined" && payload.params.without_user !== null
            ? payload.params.without_user
            : "",
        with_contact:
          typeof payload.params.with_contact !== "undefined" && payload.params.with_contact !== null
            ? payload.params.with_contact
            : "",
        without_contact:
          typeof payload.params.without_contact !== "undefined" && payload.params.without_contact !== null
            ? payload.params.without_contact
            : "",
        with_pageviewed:
          typeof payload.params.with_pageviewed !== "undefined" && payload.params.with_pageviewed !== null
            ? payload.params.with_pageviewed
            : "",
        without_pageviewed:
          typeof payload.params.without_pageviewed !== "undefined" && payload.params.without_pageviewed !== null
            ? payload.params.without_pageviewed
            : "",
        with_custom:
          typeof payload.params.with_custom !== "undefined" && payload.params.with_custom !== null
            ? payload.params.with_custom
            : "",
        without_custom:
          typeof payload.params.without_custom !== "undefined" && payload.params.without_custom !== null
            ? payload.params.without_custom
            : "",
        time_col:
          typeof payload.params.time_col !== "undefined" && payload.params.time_col !== null
            ? payload.params.time_col
            : "",
        time_relative:
          typeof payload.params.time_relative !== "undefined" && payload.params.time_relative !== null
            ? payload.params.time_relative
            : "",
        time_from:
          typeof payload.params.time_from !== "undefined" && payload.params.time_from !== null
            ? payload.params.time_from
            : "",
        time_to:
          typeof payload.params.time_to !== "undefined" && payload.params.time_to !== null
            ? payload.params.time_to
            : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsGet(params)
            .then((res) => {
              console.log("teamProjectsGet", res);
              commit("PROJECTS_SET_PROJECT_LIST", res.data.data);
              commit("PROJECTS_SET_PROJECTS_STATI", res.data.meta.status);
              if (payload.setListsSettings) {
                let customFilters = [];
                let filterName = "";
                if (params.with_custom) {
                  params.with_custom.forEach((val) => {
                    filterName = "with_custom_" + val.split(".")[0];
                    if (!customFilters[filterName]) customFilters[filterName] = [];
                    customFilters[filterName].push(val.split(".")[1]);
                  });
                }
                if (params.without_custom) {
                  params.without_custom.forEach((val) => {
                    filterName = "without_custom_" + val.split(".")[0];
                    if (!customFilters[filterName]) customFilters[filterName] = [];
                    customFilters[filterName].push(val.split(".")[1]);
                  });
                }
                commit("GLOBAL_SET_LISTS_SETTINGS", {
                  list: payload.list ? payload.list : "projects",
                  pagination: {
                    page: res.data.meta.pagination.current_page,
                    perPage: res.data.meta.pagination.per_page,
                    lastPage: res.data.meta.pagination.last_page,
                    total: res.data.meta.pagination.total,
                  },
                  order: {
                    col: params.order_col,
                    dir: params.order_dir,
                  },
                  search: params.search,
                  filter: {
                    is_posted: params.is_posted,
                    is_visited: params.is_visited,
                    is_private: params.is_private,
                    is_archived: params.is_archived,
                    is_subscribed: params.is_subscribed,
                    is_mine: params.is_mine,
                    has_uploads: params.has_uploads,
                    has_downloads: params.has_downloads,
                    has_file_signings: params.has_file_signings,
                    has_messages: params.has_messages,
                    has_any_messages: params.has_any_messages,
                    has_unread_messages: params.has_unread_messages,
                    action_required: params.action_required,
                    has_ces_daily_above: params.has_ces_daily_above,
                    has_ces_total_above: params.has_ces_total_above,
                    has_file_previews: params.has_file_previews,
                    with_status: params.with_status,
                    without_status: params.without_status,
                    with_template: params.with_template,
                    without_template: params.without_template,
                    with_contact: params.with_contact,
                    without_contact: params.without_contact,
                    with_tag: params.with_tag,
                    without_tag: params.without_tag,
                    with_user: params.with_user,
                    without_user: params.without_user,
                    with_pageviewed: params.with_pageviewed.length > 0 ? params.with_pageviewed : "",
                    without_pageviewed: params.without_pageviewed,
                    time_col: params.time_col,
                    time_relative: params.time_relative === "custom" ? "custom" : params.time_relative,
                    time_from: params.time_from,
                    time_to: params.time_to,
                  },
                  customFilters,
                });
              }
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  resetProjectFilterValues({}, payload = {}) {
    return new Promise((resolve) => {
      if (!payload.params) payload.params = {};
      payload.params.is_posted = "";
      payload.params.is_visited = "";
      payload.params.is_mine = "";
      payload.params.is_private = "";
      payload.params.is_archived = "";
      payload.params.is_subscribed = "";
      payload.params.has_uploads = "";
      payload.params.has_downloads = "";
      payload.params.has_file_signings = "";
      payload.params.has_messages = "";
      payload.params.has_any_messages = "";
      payload.params.has_unread_messages = "";
      payload.params.action_required = "";
      payload.params.has_ces_daily_above = "";
      payload.params.has_ces_total_above = "";
      payload.params.has_file_previews = "";
      payload.params.with_status = "";
      payload.params.without_status = "";
      payload.params.with_tag = "";
      payload.params.without_tag = "";
      payload.params.with_template = "";
      payload.params.without_template = "";
      payload.params.with_user = "";
      payload.params.without_user = "";
      payload.params.with_contact = "";
      payload.params.without_contact = "";
      payload.params.with_pageviewed = "";
      payload.params.without_pageviewed = "";
      payload.params.with_custom = "";
      payload.params.without_custom = "";
      payload.params.time_col = "";
      payload.params.time_relative = "";
      payload.params.time_from = "";
      payload.params.time_to = "";
      resolve();
    });
  },
  getProject({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        project: payload.project,
        include_unread_message_count:
          typeof payload.params.include_unread_message_count !== "undefined" &&
          payload.params.include_unread_message_count !== null
            ? payload.params.include_unread_message_count
            : "",
        include_subscribed:
          typeof payload.params.include_subscribed !== "undefined" && payload.params.include_subscribed !== null
            ? payload.params.include_subscribed
            : "",
        include_latest_message_date:
          typeof payload.params.include_latest_message_date !== "undefined" &&
          payload.params.include_latest_message_date !== null
            ? payload.params.include_latest_message_date
            : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectGet(params)
            .then((res) => {
              console.log("teamProjectsProjectGet", res);
              commit("PROJECTS_SET_CURRENT_PROJECT", res.data.data);
              commit("PROJECTS_SET_CURRENT_PROJECT_CUSTOM_FIELDS", res.data.meta.custom);
              commit("PROJECTS_SET_CURRENT_PROJECT_CRM_FIELDS", res.data.meta.crm);
              commit("PROJECTS_SET_PROJECT_STATI", res.data.meta.status);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response, { name: "project" });
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  editProject({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectPut(params, payload.data)
            .then((res) => {
              console.log("teamProjectsProjectPut", res);
              if (payload.tags) {
                payload.params = { project: res.data.data.uid };
                payload.data = payload.tags;
                dispatch("editProjectTags", payload).then(() => {
                  commit("PROJECTS_SET_CURRENT_PROJECT", res.data.data);
                  resolve(res.data.data);
                });
              } else {
                commit("PROJECTS_SET_CURRENT_PROJECT", res.data.data);
                if (!payload.redirect) commit("GLOBAL_LOADING_ENDED");
                resolve(res.data.data);
              }
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response, { name: "project" });
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  duplicateProject({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectClonePost(params, payload.data)
            .then((res) => {
              console.log("teamProjectsProjectPut", res);
              commit("PROJECTS_SET_CURRENT_PROJECT", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response, { name: "project" });
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  deleteProject({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectDelete(params)
            .then((res) => {
              console.log("teamProjectsProjectDelete", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getProjectTags({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        project: payload.project,
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "1000",
        order_col: payload.params.order_col ? payload.params.order_col : "name",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "ASC",
        name: payload.params.name ? payload.params.name : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectTagsGet(params)
            .then((res) => {
              console.log("teamProjectsProjectTagsGet", res.data.data);
              commit("PROJECTS_SET_CURRENT_PROJECT_TAGS", res.data.data);
              if (res.data.meta) commit("PROJECTS_SET_CURRENT_PROJECT_TAGS_PAGINATION", res.data.meta.pagination);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  editProjectTags({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectTagsPut(params, payload.tags)
            .then((res) => {
              console.log("teamProjectsProjectTagsPut", res.data.data);
              if (!payload.redirect) commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  setProjectPosted({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      if (!payload.data) payload.data = {};
      payload.data = {
        channel: payload.data.channel ? payload.data.channel : "email",
        subject: payload.data.subject ? payload.data.subject : "",
        body: payload.data.body ? payload.data.body : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectPostingsPost(params, payload.data)
            .then((res) => {
              console.log("teamProjectsProjectPostingsPost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getProjectBuilderSession({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectBuilderSessionPost(params, payload.data)
            .then((res) => {
              console.log("teamProjectsProjectBuilderSessionPost", res);
              commit("PROJECTS_SET_BUILDER_SESSION", res.data.data.builder);
              resolve();
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getProjectMessages({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        project: payload.project,
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "10",
        order_col: payload.params.order_col ? payload.params.order_col : "created_at",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "DESC",
        search: payload.params.search ? payload.params.search : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectMessagesGet(params)
            .then((res) => {
              console.log("teamProjectsProjectMessagesGet", res);
              commit("PROJECTS_SET_PROJECT_MESSAGES", { messages: res.data.data, reset: payload.reset });
              commit("PROJECTS_SET_MESSAGES_PAGINATION", res.data.meta.pagination);
              commit("PROJECTS_SET_PROJECTS_MESSAGES_WHATSAPP_META", res.data.meta.whatsapp);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  sendProjectMessage({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectMessagesPost(params, payload.data)
            .then((res) => {
              console.log("teamProjectsProjectMessagesPost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve();
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getProjectsMessages({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "1000",
        order_col: payload.params.order_col ? payload.params.order_col : "created_at",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "ASC",
        search: payload.params.search ? payload.params.search : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectmessagesGet(params)
            .then((res) => {
              console.log("teamProjectmessagesGet", res);
              commit("PROJECTS_SET_PROJECTS_MESSAGES", res.data.data);
              commit("PROJECTS_SET_PROJECTS_MESSAGES_PAGINATION", res.data.meta.pagination);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  createProject({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", {})
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsPost(params, payload.data)
            .then((res) => {
              console.log("teamProjectsPost", res);
              if (payload.tags) {
                payload.params = { project: res.data.data.uid };
                payload.data = payload.tags;
                dispatch("editProjectTags", payload).then(() => {
                  commit("PROJECTS_SET_CURRENT_PROJECT", res.data.data);
                  resolve(res.data.data);
                });
              } else {
                commit("PROJECTS_SET_CURRENT_PROJECT", res.data.data);
                if (!payload.redirect) commit("GLOBAL_LOADING_ENDED");
                resolve(res.data.data);
              }
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getProjectFiles({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        project: payload.project,
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "title",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "ASC",
        search: payload.params.search ? payload.params.search : "",
        external_id: payload.params.external_id ? payload.params.external_id : "",
        type: payload.params.type ? payload.params.type : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectFilesGet(params)
            .then((res) => {
              console.log("teamProjectsProjectFilesGet", res);
              commit("PROJECTS_SET_PROJECT_FILES", res.data.data);
              if (payload.setListsSettings) {
                commit("GLOBAL_SET_LISTS_SETTINGS", {
                  list: "uploads",
                  pagination: {
                    page: res.data.meta.pagination.current_page,
                    perPage: res.data.meta.pagination.per_page,
                    lastPage: res.data.meta.pagination.last_page,
                  },
                  order: {
                    col: params.order_col,
                    dir: params.order_dir,
                  },
                  search: params.search,
                });
              }
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getProjectFile({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectFilesFileGet(params)
            .then((res) => {
              console.log("teamProjectsProjectFilesFileGet", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getProjectFileImagePreview({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        project: payload.project,
        file: payload.file,
        page: payload.params.page ? payload.params.page : "1",
        width: payload.params.width ? payload.params.width : "100",
        height: payload.params.height ? payload.params.height : "100",
        rendermethod: payload.params.rendermethod ? payload.params.rendermethod : "fit",
        redirect: payload.params.redirect ? payload.params.redirect : false,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectFilesFilePreviewImageRendermethodPageWidthHeightGet(params)
            .then((res) => {
              console.log("teamProjectsProjectFilesFilePreviewImageRendermethodPageWidthHeightGet", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data.redirect);
            })
            .catch((err) => {
              console.log(err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getProjectFilePreview({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        project: payload.project,
        file: payload.file,
        any: payload.any ? payload.any : "",
        redirect: payload.params.redirect ? payload.params.redirect : false,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectFilesFilePreviewFileAnyGet(params)
            .then((res) => {
              console.log("teamProjectsProjectFilesFilePreviewFileAnyGet", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data.redirect);
            })
            .catch((err) => {
              console.log(err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  downloadProjectFile({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectFilesFileDownloadGet(params)
            .then((res) => {
              console.log("teamProjectsProjectFilesFileDownloadGet", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log(err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  downloadProjectFileSigningSummary({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectFilesFileSigningSummaryGet(params)
            .then((res) => {
              console.log("teamProjectsProjectFilesFileSigningSummaryGet", res.data.data);
              const blob = new Blob([res.data], {
                type: "application/pdf",
              });
              FileSaver.saveAs(blob, "file-signing-summary.pdf");
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log(err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  deleteProjectFile({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectFilesFileDelete(params)
            .then((res) => {
              console.log("teamProjectsProjectFilesFileDelete", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  createProjectFiles({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectFilesPost(params, payload.data)
            .then((res) => {
              console.log("teamProjectsProjectFilesPost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getProjectsStats({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      const urlParams = new URLSearchParams(window.location.search);
      const queryParamFrom = urlParams.get("from");
      if (queryParamFrom) {
        dispatch("resetProjectFilterValues", payload);
      }
      if (queryParamFrom === "hot-projects") {
        payload.params.order_col = "ces_daily";
        payload.params.order_dir = "DESC";
        payload.params.has_ces_daily_above = 25;
      } else if (queryParamFrom === "action-required-projects") {
        payload.params.order_col = "ces_daily";
        payload.params.order_dir = "ASC";
        payload.params.action_required = true;
      } else if (queryParamFrom === "dead-projects") {
        payload.params.order_col = "created_at";
        payload.params.order_dir = "DESC";
        payload.params.is_posted = true;
        payload.params.time_col = "last_active_at";
        payload.params.time_relative = "custom";
        payload.params.time_from = $moment.tz($moment().subtract(50, "y"), payload.timezone).format();
        payload.params.time_to = $moment.tz($moment().subtract(7, "d"), payload.timezone).format();
      } else if (queryParamFrom === "live-visitors") {
        payload.params.order_col = "last_active_at";
        payload.params.order_dir = "DESC";
      }

      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "last_active_at",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "DESC",
        search: payload.params.search ? payload.params.search : "",
        external_id: payload.params.external_id ? payload.params.external_id : "",
        custom: payload.params.custom ? payload.params.custom : "",
        include_stats:
          typeof payload.params.include_stats !== "undefined" && payload.params.include_stats !== null
            ? payload.params.include_stats
            : "",
        include_message_count:
          typeof payload.params.include_message_count !== "undefined" && payload.params.include_message_count !== null
            ? payload.params.include_message_count
            : "",
        include_unread_message_count:
          typeof payload.params.include_unread_message_count !== "undefined" &&
          payload.params.include_unread_message_count !== null
            ? payload.params.include_unread_message_count
            : "",
        include_latest_message_date:
          typeof payload.params.include_latest_message_date !== "undefined" &&
          payload.params.include_latest_message_date !== null
            ? payload.params.include_latest_message_date
            : "",
        include_subscribed:
          typeof payload.params.include_subscribed !== "undefined" && payload.params.include_subscribed !== null
            ? payload.params.include_subscribed
            : "",
        is_posted:
          typeof payload.params.is_posted !== "undefined" && payload.params.is_posted !== null
            ? payload.params.is_posted
            : "",
        is_visited:
          typeof payload.params.is_visited !== "undefined" && payload.params.is_visited !== null
            ? payload.params.is_visited
            : "",
        is_mine:
          typeof payload.params.is_mine !== "undefined" && payload.params.is_mine !== null
            ? payload.params.is_mine
            : "",
        is_private:
          typeof payload.params.is_private !== "undefined" && payload.params.is_private !== null
            ? payload.params.is_private
            : "",
        is_archived:
          typeof payload.params.is_archived !== "undefined" && payload.params.is_archived !== null
            ? payload.params.is_archived
            : "",
        is_subscribed:
          typeof payload.params.is_subscribed !== "undefined" && payload.params.is_subscribed !== null
            ? payload.params.is_subscribed
            : "",
        has_uploads:
          typeof payload.params.has_uploads !== "undefined" && payload.params.has_uploads !== null
            ? payload.params.has_uploads
            : "",
        has_downloads:
          typeof payload.params.has_downloads !== "undefined" && payload.params.has_downloads !== null
            ? payload.params.has_downloads
            : "",
        has_file_signings:
          typeof payload.params.has_file_signings !== "undefined" && payload.params.has_file_signings !== null
            ? payload.params.has_file_signings
            : "",
        has_messages:
          typeof payload.params.has_messages !== "undefined" && payload.params.has_messages !== null
            ? payload.params.has_messages
            : "",
        has_any_messages:
          typeof payload.params.has_any_messages !== "undefined" && payload.params.has_any_messages !== null
            ? payload.params.has_any_messages
            : "",
        has_unread_messages:
          typeof payload.params.has_unread_messages !== "undefined" && payload.params.has_unread_messages !== null
            ? payload.params.has_unread_messages
            : "",
        action_required:
          typeof payload.params.action_required !== "undefined" && payload.params.action_required !== null
            ? payload.params.action_required
            : "",
        has_ces_daily_above:
          typeof payload.params.has_ces_daily_above !== "undefined" && payload.params.has_ces_daily_above !== null
            ? payload.params.has_ces_daily_above
            : "",
        has_ces_total_above:
          typeof payload.params.has_ces_total_above !== "undefined" && payload.params.has_ces_total_above !== null
            ? payload.params.has_ces_total_above
            : "",
        has_file_previews:
          typeof payload.params.has_file_previews !== "undefined" && payload.params.has_file_previews !== null
            ? payload.params.has_file_previews
            : "",
        with_status:
          typeof payload.params.with_status !== "undefined" && payload.params.with_status !== null
            ? payload.params.with_status
            : "",
        without_status:
          typeof payload.params.without_status !== "undefined" && payload.params.without_status !== null
            ? payload.params.without_status
            : "",
        with_tag:
          typeof payload.params.with_tag !== "undefined" && payload.params.with_tag !== null
            ? payload.params.with_tag
            : "",
        without_tag:
          typeof payload.params.without_tag !== "undefined" && payload.params.without_tag !== null
            ? payload.params.without_tag
            : "",
        with_template:
          typeof payload.params.with_template !== "undefined" && payload.params.with_template !== null
            ? payload.params.with_template
            : "",
        without_template:
          typeof payload.params.without_template !== "undefined" && payload.params.without_template !== null
            ? payload.params.without_template
            : "",
        with_user:
          typeof payload.params.with_user !== "undefined" && payload.params.with_user !== null
            ? payload.params.with_user
            : "",
        without_user:
          typeof payload.params.without_user !== "undefined" && payload.params.without_user !== null
            ? payload.params.without_user
            : "",
        with_contact:
          typeof payload.params.with_contact !== "undefined" && payload.params.with_contact !== null
            ? payload.params.with_contact
            : "",
        without_contact:
          typeof payload.params.without_contact !== "undefined" && payload.params.without_contact !== null
            ? payload.params.without_contact
            : "",
        with_pageviewed:
          typeof payload.params.with_pageviewed !== "undefined" && payload.params.with_pageviewed !== null
            ? payload.params.with_pageviewed
            : "",
        without_pageviewed:
          typeof payload.params.without_pageviewed !== "undefined" && payload.params.without_pageviewed !== null
            ? payload.params.without_pageviewed
            : "",
        with_custom:
          typeof payload.params.with_custom !== "undefined" && payload.params.with_custom !== null
            ? payload.params.with_custom
            : "",
        without_custom:
          typeof payload.params.without_custom !== "undefined" && payload.params.without_custom !== null
            ? payload.params.without_custom
            : "",
        time_col:
          typeof payload.params.time_col !== "undefined" && payload.params.time_col !== null
            ? payload.params.time_col
            : "",
        time_relative:
          typeof payload.params.time_relative !== "undefined" && payload.params.time_relative !== null
            ? payload.params.time_relative
            : "",
        time_from:
          typeof payload.params.time_from !== "undefined" && payload.params.time_from !== null
            ? payload.params.time_from
            : "",
        time_to:
          typeof payload.params.time_to !== "undefined" && payload.params.time_to !== null
            ? payload.params.time_to
            : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsstatsGet(params)
            .then((res) => {
              console.log("teamProjectsstatsGet", res);
              commit("PROJECTS_SET_PROJECTS_STATS", res.data.data);
              commit("PROJECTS_SET_PROJECTS_STATI", res.data.meta.status);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getProjectStats({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectStatsGet(params)
            .then((res) => {
              console.log("teamProjectsProjectStatsGet", res);
              commit("PROJECTS_SET_PROJECT_STATS", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  setProjectsActivityFeedsRead({ dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamFeedsActivityReadPut(params)
            .then((res) => {
              console.log("teamFeedsActivityReadPut", res);
              resolve();
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          reject(err);
        });
    });
  },
  setVisitorSync({ dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsSyncVisitorsPost(params)
            .then((res) => {
              console.log("teamProjectsSyncVisitorsPost", res);
              resolve();
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          reject(err);
        });
    });
  },
  getProjectGuests({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectGuestsGet(params)
            .then((res) => {
              console.log("teamProjectsProjectGuestsGet", res);
              commit("PROJECTS_SET_CURRENT_PROJECT_GUESTS", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  addProjectGuest({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectGuestsPost(params, payload.data)
            .then((res) => {
              console.log("teamProjectsProjectGuestsPost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  deleteProjectGuest({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectGuestsGuestDelete(params)
            .then((res) => {
              console.log("teamProjectsProjectGuestsGuestDelete", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getProjectContact({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectContactsContactGet(params)
            .then((res) => {
              console.log("teamProjectsProjectContactsContactGet", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
